<template>
  <div class="showcase-header">
    <div class="brand">
      <button class="button basic text" @click="onClickAppLogo">
        <AppLogo name="full" color="#fff" />
      </button>
    </div>
    <div class="action">
      <a
        class="link"
        target="_blank"
        href="https://ninghao.net/cart/add/e_s-p9077?destination=cart/checkout"
        >报名</a
      >
      <div class="separator">/</div>
      <button class="button basic text" @click="onClickLoginButton">
        登录
      </button>
      <div class="arrow">→</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapMutations, mapGetters } from 'vuex';
import AppLogo from '@/app/components/app-logo';

export default defineComponent({
  name: 'ShowcaseHeader',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    onClickLoginButton() {
      this.setCurrentStepName('login');
    },

    onClickAppLogo() {
      if (this.isLoggedIn) {
        this.$router.push('/');
      } else {
        this.setCurrentStepName('initial');
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppLogo,
  },
});
</script>

<style scoped>
@import './styles/showcase-header.css';
</style>
